<template>
    <div class="well-id" :title="$translate('well_number')">
        <template v-if="isGeriOrMiri">
            <span v-b-tooltip.hover :title="$translate('well')">
                {{ $translate('well') }} {{ well.esId }}
            </span>
        </template>
        <template v-else>
            <span v-b-tooltip.hover :title="$translate('slide')">{{ slide.esId }}</span>
            /
            <span v-b-tooltip.hover :title="$translate('well')">{{ well.esId }}</span>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { INSTRUMENT_TYPE } from '../../business/const'

export default {
    name: 'WellId',
    props: {
        well: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState({
            selectedTreatment: state => state.timelapse.selectedTreatment
        }),
        ...mapGetters({
            getSelectedInstrument: 'timelapse/getSelectedInstrument'
        }),
        slide() {
            const { slides } = this.selectedTreatment

            return slides.find(slide => slide._id === this.well.slideId)
        },
        isGeriOrMiri() {
            return (
                this.getSelectedInstrument.type &&
                [INSTRUMENT_TYPE.GERI, INSTRUMENT_TYPE.MIRI].includes(
                    this.getSelectedInstrument.type
                )
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.well-id {
    white-space: nowrap;
    color: $light-3;
    border-radius: $border-radius-sm;
    margin-left: 0.5rem;
}
</style>
